import { useReducer, useEffect } from "react";

import Reducer from "./reducer";
import Context from "./context";
import { initialState } from "./initialState";
import Html from "./html";

const Search = ({ onSearch, width, is_filter, type="text" }) => {
    const [state, dispatch] = useReducer(Reducer,initialState);

    useEffect(() => {
        const sendSearchTextToParent = () => {
            onSearch(state.search_text);
        };

        !is_filter && sendSearchTextToParent();
    }, [state.search_text]);

    return(
        <Context.Provider value={{state, dispatch}}>
            <Html 
                width = {width} 
                is_filter = {is_filter}
                onSearch = {onSearch}
                type = {type}
            />
        </Context.Provider>
    );
}

export default Search;